import React from 'react';
import {
  ExtensionSlot,
} from 'piral-core';

// Helper function to render multiple extension slots
const renderSlots = (baseName, props, maxSlots = 20) => {
  const slots = [];

  // Render numbered slots (e.g., "slot-1", "slot-2", etc.)
  for (let i = 1; i <= maxSlots; i++) {
    slots.push(<ExtensionSlot key={`${baseName}-${i}`} name={`${baseName}-${i}`} params={props} />);
  }

  return slots;
};

/**
 * Vertical Layout Component (Stack Layout)
 * 
 * This layout stacks content vertically from top to bottom.
 * Each slot takes the full width and height is determined by content.
 * 
 * AVAILABLE EXTENSION SLOTS:
 * - "slot-1", "slot-2", "slot-3", ... up to "slot-20"
 * 
 * USE CASE:
 * - Landing pages
 * - Content-heavy pages with sections
 * - Forms
 * - Article layouts
 * 
 */
export default {
  Layout: (props) => {
    const { pageKey, ...otherProps } = props;
    const prefix = `${pageKey || ''}-`;
    
    return (
      <div style={{
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        width: '100%',
        overflowY: 'auto'
      }}>
        {renderSlots(`${prefix}slot`, otherProps)}
      </div>
    );
  },
}
